import { render, staticRenderFns } from "./Trend.vue?vue&type=template&id=5c103a0a&"
import script from "./Trend.vue?vue&type=script&lang=js&"
export * from "./Trend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c103a0a')) {
      api.createRecord('5c103a0a', component.options)
    } else {
      api.reload('5c103a0a', component.options)
    }
    module.hot.accept("./Trend.vue?vue&type=template&id=5c103a0a&", function () {
      api.rerender('5c103a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/Trend.vue"
export default component.exports